"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Edit = function Edit(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    height: "40",
    width: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.067,3.986c-0.094-0.094-0.221-0.148-0.354-0.148l0,0c-0.133,0-0.26,0.053-0.354,0.147L3.437,14.91 c-0.195,0.195-0.195,0.512,0,0.707l4.948,4.948c0.195,0.195,0.512,0.195,0.707,0L20.009,9.648c0.195-0.195,0.195-0.511,0-0.706 L15.067,3.986z M2.43,16.8c-0.128-0.128-0.315-0.176-0.489-0.127c-0.174,0.049-0.308,0.188-0.351,0.364l-1.506,6.277 c-0.04,0.169,0.01,0.347,0.133,0.47c0.124,0.121,0.301,0.171,0.47,0.132l6.272-1.5c0.269-0.064,0.434-0.334,0.37-0.603 c-0.022-0.09-0.068-0.172-0.133-0.237L2.43,16.8z M23.2,2.924L21.077,0.8c-0.976-0.974-2.556-0.974-3.532,0l-1.418,1.417 c-0.195,0.195-0.195,0.512,0,0.707l4.95,4.949c0.195,0.195,0.512,0.195,0.707,0L23.2,6.454C24.173,5.478,24.173,3.9,23.2,2.924z",
    fill: fill,
    stroke: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Edit.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Edit.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Edit;